// src/utils/responderPorCanal.js

/**
 * Perfiles de salida por canal. Idealmente estos valores van en .env:
 *  - VITE_INFOBIP_BASE_URL, VITE_INFOBIP_API_KEY, VITE_INFOBIP_FROM_MAYORISTA, VITE_INFOBIP_FROM_CONSUMIDOR
 *  - VITE_TG_BOT_MAYORISTA, VITE_TG_BOT_CONSUMIDOR
 * Acá dejamos fallback a los valores que ya tenías, para que funcione ya mismo.
 */
const CONFIG = {
    WhatsApp: {
        mayorista: {
            baseUrl: "https://v3xvwv.api.infobip.com",
            apiKey:
                "App 77b973f0fa17e1f6c49175d44b529718-df43d4da-51e6-4e7b-8ba2-aca8cb3dd5c5",
            from:
                "12134250460", // ← tu número actual
        },
        consumidor: {
            baseUrl: "https://v3xvwv.api.infobip.com",
            apiKey:
                "App 77b973f0fa17e1f6c49175d44b529718-df43d4da-51e6-4e7b-8ba2-aca8cb3dd5c5",
            from:
                "5491168404947", // ← poné acá el otro número si lo tenés
        },
    },
    Telegram: {
        mayorista: {
            token:
                "7878413507:AAFtqr0Qd392CJoUs5G7JpPoeKyUgBtzzB8",
        },
        consumidor: {
            token:
                "7878413507:AAFtqr0Qd392CJoUs5G7JpPoeKyUgBtzzB8",
        },
    },
};


export default async function responderPorCanal(
    channel,
    recipientId,
    message,
    { profile = "mayorista", overrides = {} } = {}
) {
    if (channel === "Telegram") {
        const { token } = { ...CONFIG.Telegram[profile], ...overrides };
        const url = `https://api.telegram.org/bot${token}/sendMessage`;
        return fetch(url, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ chat_id: recipientId, text: message }),
        });
    }

    if (channel === "WhatsApp") {
        const { baseUrl, apiKey, from } = { ...CONFIG.WhatsApp[profile], ...overrides };
        const url = `${baseUrl}/whatsapp/1/message/text`;
        return fetch(url, {
            method: "POST",
            headers: {
                Authorization: apiKey,
                "Content-Type": "application/json",
                Accept: "application/json",
            },
            body: JSON.stringify({
                from,           // ← sale por el número del perfil
                to: recipientId,
                content: { text: message },
            }),
        });
    }

    console.warn(`Canal no soportado: ${channel}`);
    return Promise.resolve(new Response(null, { status: 204 }));
}
